module.exports = __webpack_public_path__ + "img/zhwl3.8b7fbc81.png";